import { useState, useEffect } from "react";
import { BRAND_COLORS } from "../../../theme/colors.js";

export default function ShowreelModal({ onClose }) {
  const [dots, setDots] = useState([]);

  useEffect(() => {
    const newDots = Array.from({ length: 60 }, (_, i) => ({
      x: Math.random() * 100, y: Math.random() * 100,
      size: Math.random() * 8 + 2, speed: Math.random() * 0.5 + 0.1,
      color: [BRAND_COLORS.red, BRAND_COLORS.blue, BRAND_COLORS.purple, BRAND_COLORS.cyan, BRAND_COLORS.orange][i % 5],
      angle: Math.random() * Math.PI * 2, orbit: Math.random() * 30 + 10,
    }));
    setDots(newDots);
  }, []);

  const [time, setTime] = useState(0);
  useEffect(() => {
    const raf = () => { setTime(t => t + 0.008); animRef.current = requestAnimationFrame(raf); };
    const animRef = { current: requestAnimationFrame(raf) };
    return () => cancelAnimationFrame(animRef.current);
  }, []);

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, background: BRAND_COLORS.darker, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", animation: "fadeIn 0.6s ease" }}>
      <button onClick={onClose} style={{ position: "absolute", top: 32, right: 32, background: "none", border: "1px solid rgba(255,255,255,0.2)", color: "#fff", width: 44, height: 44, borderRadius: "50%", fontSize: 20, cursor: "pointer", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s" }} onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.1)"; }} onMouseLeave={e => { e.currentTarget.style.background = "none"; }}>×</button>
      {dots.map((dot, i) => {
        const x = dot.x + Math.cos(dot.angle + time * dot.speed) * dot.orbit;
        const y = dot.y + Math.sin(dot.angle + time * dot.speed) * dot.orbit;
        return <div key={i} style={{ position: "absolute", left: `${x}%`, top: `${y}%`, width: dot.size, height: dot.size, borderRadius: "50%", background: dot.color, opacity: 0.6 + Math.sin(time * 2 + i) * 0.3, filter: `blur(${dot.size > 5 ? 2 : 0}px)`, transition: "left 0.05s linear, top 0.05s linear" }} />;
      })}
      <div style={{ textAlign: "center", zIndex: 5, display: "flex", flexDirection: "column", alignItems: "center", gap: 24 }}>
        <div style={{ width: 200, height: 200, border: `2px solid ${BRAND_COLORS.cyan}`, borderRadius: `${30 + Math.sin(time) * 20}% ${70 - Math.sin(time) * 20}% ${30 + Math.cos(time) * 20}% ${70 - Math.cos(time) * 20}%`, display: "flex", alignItems: "center", justifyContent: "center", transition: "border-radius 0.3s ease", boxShadow: `0 0 60px ${BRAND_COLORS.purple}44` }} />
        <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 14, fontFamily: "monospace", letterSpacing: 4, textTransform: "uppercase" }}>Showreel Coming Soon</div>
        <div style={{ color: "rgba(255,255,255,0.62)", fontSize: 14, fontFamily: "monospace", maxWidth: 400, lineHeight: 1.8 }}>A creative agency built by professional athletes, physicists,<br />authors, engineers, and material scientists.</div>
        <div style={{ display: "flex", gap: 3, alignItems: "flex-end", height: 40, marginTop: 20 }}>
          {Array.from({ length: 24 }, (_, i) => (
            <div key={i} style={{ width: 3, height: `${20 + Math.abs(Math.sin(time * 3 + i * 0.5)) * 20}px`, background: `linear-gradient(180deg, ${BRAND_COLORS.cyan}, ${BRAND_COLORS.purple})`, borderRadius: 2, opacity: 0.7 }} />
          ))}
        </div>
      </div>
    </div>
  );
}
